module.exports = __webpack_public_path__ + "assets/images/login_bg.35003441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.png
// module id = 4156
// module chunks = 1582 1583 1585